export enum ConnectContextActionTypes {
  SET_CONTACTED_SCHOOL_IDS = 'SET_CONTACTED_SCHOOL_IDS',
  SET_IS_LOADING = 'SET_IS_LOADING',
  SET_IS_MORE_INFO_SLIDER_OPEN = 'SET_IS_MORE_INFO_SLIDER_OPEN',
  SET_IS_USER_AUTHENTICATED = 'SET_IS_USER_AUTHENTICATED',
  SET_SELECTED_SCHOOL = 'SET_SELECTED_SCHOOL',
  SET_SELECTED_VACANCY_ID = 'SET_SELECTED_VACANCY_ID',
  TOGGLE_SAVED_SCHOOL_IDS = 'TOGGLE_SAVED_SCHOOL_IDS',
  SET_CANDIDATE_MATCHES = 'SET_CANDIDATE_MATCHES',
  SET_HAS_INITIALLY_FETCHED_MATCHES = 'SET_HAS_INITIALLY_FETCHED_MATCHES',
  SET_IS_FETCHING_MATCHES = 'SET_IS_FETCHING_MATCHES',
  SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN',
}

export enum ConnectModals {
  AUTHENTICATED_ADMIN_MODAL = 'AuthenticatedAdminModal',
  EXPRESS_INTEREST_EXIT_MODAL = 'ExpressInterestExitModal',
  EXPRESS_INTEREST_MODAL = 'ExpressInterestModal',
  MATCH_QUIZ_ACCESS_MODAL = 'MatchQuizAccessModal',
  READY_TO_CONNECT_MODAL = 'ReadyToConnectModal',
}

export enum JobDiscoveryActionTypes {
  SET_PAGE = 'SET_PAGE',
  SET_QUERY = 'SET_QUERY',
  SET_FILTER = 'SET_FILTER',
  SET_FILTER_IS_ACTIVE = 'SET_FILTER_IS_ACTIVE',
  SET_USE_DEBOUNCE = 'SET_USE_DEBOUNCE',
  SET_SCHOOLS = 'SET_SCHOOLS',
  SET_IS_LOADING_INITIAL_FILTER_RESULTS = 'SET_IS_LOADING_INITIAL_FILTER_RESULTS',
}

export enum ConnectBadgeLabels {
  DISTRICTWIDE = 'District-wide',
  ON_PLATFORM = 'Responds quickly',
  RECOMMENDED = 'Recommended',
}

export enum ConnectFilterName {
  SUBCATEGORIES = 'subcategories',
  DISTANCE_RADIUS_MILES = 'distance_radius_miles',
  LOCATION = 'location',
  GRADES = 'grades',
  SCHOOLS = 'school_nces_ids',
  DISTRICTS = 'district_nces_ids',
}

export enum ConnectURLActions {
  INFO = 'info',
}

export enum ConnectGatedActions {
  ALERT = 'alert', // This feature was sunset in nim-3920. It's not considered valid gated action.
  DIRECT = 'direct',
  EXPRESS_INTEREST = 'express_interest',
  SAVE_SCHOOL = 'save_school',
  SIGNUP_BUTTON = 'signup_button',
  LOGIN_BUTTON = 'login_button',
  SIGNUP_BANNER = 'signup_banner',
}

export enum ConnectCandidatePortalActionTypes {
  SET_UNACTIONED_MATCHES = 'SET_UNACTIONED_MATCHES',
  TOGGLE_SAVED_SCHOOL_IDS = 'TOGGLE_SAVED_SCHOOL_IDS',
  SET_IS_LOADING = 'SET_IS_LOADING',
  SET_SELECTED_VACANCY_ID = 'SET_SELECTED_VACANCY_ID',
}

export enum ConnectSchoolTagDisplayAtLocations {
  SCHOOL_AND_MATCH_CARDS = 'school_match_cards',
  MORE_INFO_SLIDER = 'more_info_slider',
  SCHOOL_DETAIL_SECTION = 'school_detail_section',
}

export enum ConnectJobSeekingStatus {
  OPEN_TO_WORK_AND_MATCHES = 'open_to_work_and_matches',
  OPEN_TO_WORK = 'open_to_work',
  CLOSED_TO_WORK = 'closed_to_work',
}
